import { ff } from '@atlassian/jira-feature-flagging';
import { getWillShowNav4New } from './get-will-show-nav4-new';

// Return true if the old feature flags are on, or the new feature gates are on.
export const getWillShowNav4 = () => getWillShowNav4Old() || getWillShowNav4New();

// Honour either of the old feature flags.
// `jira.nav4.top-nav` can be ignored, it is only used in one place and requires `platform.atlassian.griffin-navigation-redesign` to be on as well.
// We don't inline usage of feature flags/gates as our logic to show or no show will become complex at times and should not be duplicated.
// See https://hello.atlassian.net/wiki/spaces/JNR/pages/3699574590/Rollout+technical+design+draft#Decision-points
export const getWillShowNav4Old = () =>
	ff('platform.atlassian.griffin-navigation-redesign') ||
	ff('platform.atlassian.griffin-new-page-layout');
